import { combineReducers } from '@reduxjs/toolkit'
import { rtkApi } from 'shared/api/rtkApi'
import { userSlice } from 'entities/User'
import { filterSkillsSlice } from 'features/filterSkills'
import { StateScheme } from './StateScheme'
import { filterRatingSlice } from 'features/filterRating'

const rootReducer = combineReducers({
	user: userSlice.reducer,
	filterSkills: filterSkillsSlice.reducer,
	filterRating: filterRatingSlice.reducer,
	[rtkApi.reducerPath]: rtkApi.reducer,
})

export type RootState = StateScheme
export default rootReducer
